/** Покрытия (п. 9 ТЗ). Вибрация уходит в тряску камеры — без неё оператор
 *  не чувствует разницы между асфальтом и плиткой. */

export interface SurfaceProps {
  id: string;
  name: string;
  /** Сцепление: множитель разгона/торможения и скорости поворота, 0..1 */
  grip: number;
  /**
   * Сопротивление качению при полной скорости, м/с². Действует пропорционально
   * скорости: тронуться робот может на любом покрытии, а вот держать скорость
   * на траве или в грязи — уже нет.
   */
  rolling: number;
  /** Достижимая доля максимальной скорости на этом покрытии, 0..1 */
  speedFactor: number;
  /** Занос: как быстро гасится боковая скорость (1 — мгновенно, 0 — не гасится) */
  lateralDamp: number;
  /** Амплитуда тряски камеры, м */
  vibration: number;
  color: number;
}

export const SURFACES: Record<string, SurfaceProps> = {
  asphalt: { id: 'asphalt', name: 'Асфальт', grip: 1.0, rolling: 0.15, speedFactor: 1.0, lateralDamp: 0.98, vibration: 0.002, color: 0x4a4e54 },
  tile: { id: 'tile', name: 'Плитка', grip: 0.95, rolling: 0.2, speedFactor: 0.98, lateralDamp: 0.96, vibration: 0.011, color: 0x7d7568 },
  gravel: { id: 'gravel', name: 'Грунт/гравий', grip: 0.62, rolling: 0.6, speedFactor: 0.75, lateralDamp: 0.75, vibration: 0.016, color: 0x8a7b5f },
  grass: { id: 'grass', name: 'Трава', grip: 0.55, rolling: 0.7, speedFactor: 0.65, lateralDamp: 0.8, vibration: 0.009, color: 0x4e7a3a },
  snow: { id: 'snow', name: 'Снег/лёд', grip: 0.22, rolling: 0.3, speedFactor: 0.85, lateralDamp: 0.35, vibration: 0.005, color: 0xd9e2ea },
  mud: { id: 'mud', name: 'Лужа/грязь', grip: 0.35, rolling: 0.9, speedFactor: 0.55, lateralDamp: 0.6, vibration: 0.007, color: 0x3f3a33 },
};

export const DEFAULT_SURFACE = SURFACES.asphalt;

export interface SurfaceZone {
  /** Прямоугольник в мировых координатах XZ: [x0, z0, x1, z1] */
  rect: [number, number, number, number];
  surface: string;
}

/** Карта покрытий: прямоугольные заплатки поверх базового асфальта. */
export class SurfaceMap {
  constructor(private zones: SurfaceZone[] = []) {}

  add(zone: SurfaceZone): void {
    this.zones.push(zone);
  }

  at(x: number, z: number): SurfaceProps {
    for (let i = this.zones.length - 1; i >= 0; i--) {
      const [x0, z0, x1, z1] = this.zones[i].rect;
      if (x >= x0 && x <= x1 && z >= z0 && z <= z1) {
        return SURFACES[this.zones[i].surface] ?? DEFAULT_SURFACE;
      }
    }
    return DEFAULT_SURFACE;
  }

  get all(): readonly SurfaceZone[] {
    return this.zones;
  }
}
